      var nIntervId;

      function updateCountdown(productContainer) {
          const now = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Berlin' }));
          const targetTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 14, 0, 0);
          const timeDifference = targetTime - now;
    
          const countdownElement = productContainer.querySelector('.countdown-on-grid');
          const deliveryElement = productContainer.querySelector('.delivery-1-3-tage-container');
    
          if (timeDifference <= 0 || now.getDay() === 0 || now.getDay() === 6) {
            countdownElement.style.display = 'none';
            deliveryElement.style.display = 'block';
            if (nIntervId) {
              clearInterval(nIntervId);
              nIntervId = null;
            }
          } else {
            const hours = Math.floor(timeDifference / (1000 * 60 * 60))
              .toString()
              .padStart(2, '0');
            const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60))
              .toString()
              .padStart(2, '0');
            const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000)
              .toString()
              .padStart(2, '0');
    
            productContainer.querySelector('.hours-container').innerHTML = `${hours}`;
            productContainer.querySelector('.minutes-container').innerHTML = `${minutes}`;
            productContainer.querySelector('.seconds-container').innerHTML = `${seconds}`;
    
            countdownElement.style.display = 'block';
            deliveryElement.style.display = 'none';
          }
        }
    
        productContainers = document.querySelectorAll('.stock-status-avi-3');
    
        productContainers.forEach((productContainer) => {
          updateCountdown(productContainer);
        });
    
        function reinitCountdown(){
          if (nIntervId) {
            clearInterval(nIntervId);   
          }
          nIntervId = null;
          if (!nIntervId) {
            nIntervId = setInterval(() => {
              productContainers = document.querySelectorAll('.stock-status-avi-3');
              productContainers.forEach((productContainer) => {
                updateCountdown(productContainer);
              });
            }, 1000);
          }
          
        }
        reinitCountdown();
        
        document.addEventListener("collection:reloaded", () => reinitCountdown());
    